<template>
  <div class="w-full h-screen flex justify-center items-center bg-gray-50">
    <div
        class="relative overflow-hidden"
        @click="startAnimation"
        style="width: 1000px; height: 1000px"
    >
      <template v-for="(image, imageIdx) in images" :key="imageIdx">
        <Transition :name="(aniVersion === 'fade') ? 'bounce': ''">
          <div v-show="imageIdx === curImageIdx">
            <img

                class="absolute inset-0"
                :id="'animation-' + imageIdx"
                alt=""
                :src="'/ani/symposium/' + image"
            />
            <div class="absolute bottom-12 text-xl font-light tracking-wider left-0 text-center w-full"
            >
              <span
                  class="mx-auto"
                  :class="{
                'text-white py-2 px-3 bg-red-700 rounded-3xl text-4xl relative bottom-52 mx-auto font-bold': image.includes('Herrenringe'),
                'text-white py-2 px-3 bg-red-700 rounded-3xl text-4xl relative bottom-48 left-12 font-bold': getText(image).includes('€') && !image.includes('Herrenring')
              }">
              {{ getText(image) }}
                </span>
            </div>
          </div>
        </Transition>
      </template>
    </div>
    <div class="absolute w-full text-center bottom-10 left-0">{{ curImageIdx }}</div>
  </div>
</template>

<script lang="ts">
// https://images.conftec.com/conf2010/script_picture.php?ac=&itemnumber=
import {computed, defineComponent, ref} from "vue";

export default defineComponent({
  name: "ItemAnimation",
  components: {},
  setup() {
    const curImageIdx = ref(0);

    const curAni = ref(15);
    const aniVersion: string = "fade" // fade | rotated;
    const aniSpeed = aniVersion === "fade" ? 3000 : 100;

    const images = computed(() => {
      const imageList: any = [
        [
          "Folie02/001-HR0723.jpg",
          "Folie02/002-HR0720.jpg",
          "Folie02/003-HR0725.jpg",
          "Folie02/004-HR0724.jpg",
          "Folie02/005-HR0727.jpg",
          "Folie02/006-HR0727.jpg",
          "Folie02/007-HR0744.jpg",
          "Folie02/008-HR0739.jpg",
          "Folie02/009-HR0745.jpg",
        ],
        [
          "Folie03/001-HR0727.jpg",
          "Folie03/002-HR0727.jpg",
          "Folie03/003-HR0727.jpg",
          "Folie03/004-HR0727.jpg",
          "Folie03/005-HR0727.jpg",
          "Folie03/006-HR0727.jpg",
          "Folie03/007-HR0727.jpg",
          "Folie03/008-HR0727.jpg",
          "Folie03/009-HR0727.jpg",
        ],
        [
          "Folie04/001-HR0723.jpg",
          "Folie04/002-HR0720.jpg",
          "Folie04/003-HR0725.jpg",
          "Folie04/004-HR0724.jpg",
          "Folie04/005-HR0727.jpg",
          "Folie04/006-HR0727.jpg",
          "Folie04/007-HR0744.jpg",
          "Folie04/008-HR0739.jpg",
          "Folie04/009-HR0745.jpg",
        ],
        [
          "Folie05/001-HR0727.jpg",
          "Folie05/002-HR0727.jpg",
          "Folie05/003-HR0727.jpg",
          "Folie05/004-HR0727.jpg",
          "Folie05/005-HR0727.jpg",
          "Folie05/006-HR0727.jpg",
          "Folie05/007-HR0727.jpg",
        ],
        [
          "Folie06/001-HR0726.jpg",
          "Folie06/002-HR0726.jpg",
          "Folie06/003-HR0726.jpg",
          "Folie06/004-HR0727.jpg",
          "Folie06/005-HR0723.jpg",
          "Folie06/006-HR0724.jpg",
        ],
        [
          "Folie07/001-HR0726.jpg",
          "Folie07/002-HR0726.jpg",
          "Folie07/003-HR0726.jpg",
          "Folie07/004-HR0726.jpg",
          "Folie07/005-HR0726.jpg",
          "Folie07/006-HR0726.jpg",
          "Folie07/007-HR0726.jpg",
          "Folie07/008-HR0726.jpg",
          "Folie07/009-HR0726.jpg",
        ],
        [
          "Folie08/001-HR0745.jpg",
          "Folie08/002-HR0745.jpg",
          "Folie08/003-HR0745.jpg",
          "Folie08/004-HR0745.jpg",
          "Folie08/005-HR0745.jpg",
          "Folie08/006-HR0745.jpg",
          "Folie08/007-HR0745.jpg",
          "Folie08/008-HR0745.jpg",
          "Folie08/009-HR0745.jpg",
        ],
        [
          "Folie15/001.jpg",
          "Folie15/002.jpg",
          "Folie15/003.jpg",
          "Folie15/004.jpg",
          "Folie15/005.jpg",
          "Folie15/006.jpg",
          "Folie15/007.jpg",
          "Folie15/008.jpg",
          "Folie15/009.jpg",
          "Folie15/010.jpg",
          "Folie15/011.jpg",
          "Folie15/012.jpg",
          "Folie15/013.jpg",
          "Folie15/014.jpg",
          "Folie15/015.jpg",
          "Folie15/016.jpg",
        ],
        [
          "Folie18/001.jpg",
          "Folie18/002.jpg",
          "Folie18/003.jpg",
          "Folie18/004.jpg",
        ],
        [
          "Folie19/001.jpg",
          "Folie19/002.jpg",
          "Folie19/003.jpg",
          "Folie19/004.jpg",
          "Folie19/005.jpg",
          "Folie19/006.jpg",
          "Folie19/007.jpg",
          "Folie19/008.jpg",
          "Folie19/009.jpg",
          "Folie19/010.jpg",
          "Folie19/011.jpg",
          "Folie19/012.jpg",
          "Folie19/013.jpg",
          "Folie19/014.jpg",
          "Folie19/015.jpg",
          "Folie19/016.jpg",
        ],
        [
          "Folie20-1/001.jpg",
          "Folie20-1/002.jpg",
          "Folie20-1/003.jpg",
          "Folie20-1/004.jpg",
          "Folie20-1/005.jpg",
          "Folie20-1/006.jpg",
          "Folie20-1/007.jpg",
          "Folie20-1/008.jpg",
          "Folie20-1/009.jpg",
          "Folie20-1/010.jpg",
          "Folie20-1/011.jpg",
          "Folie20-1/012.jpg",
          "Folie20-1/013.jpg",
          "Folie20-1/014.jpg",
          "Folie20-1/015.jpg",
          "Folie20-1/016.jpg",
        ],
        [
          "Folie33/001.jpg",
          "Folie33/002.jpg",
          "Folie33/003.jpg",
          "Folie33/004.jpg",
          "Folie33/005.jpg",
          "Folie33/006.jpg",
          "Folie33/007.jpg",
          "Folie33/008.jpg",
          "Folie33/009.jpg",
          "Folie33/010.jpg",
          "Folie33/011.jpg",
          "Folie33/012.jpg",
        ],
        [
          "Folie34/001.jpg",
          "Folie34/002.jpg",
          "Folie34/003.jpg",
          "Folie34/004.jpg",
          "Folie34/005.jpg",
          "Folie34/006.jpg",
        ],

        [
          "Folie54-Herrenringe/001.jpg",
          "Folie54-Herrenringe/002.jpg",
          "Folie54-Herrenringe/003.jpg",
          "Folie54-Herrenringe/004.jpg",
          "Folie54-Herrenringe/005.jpg",
          "Folie54-Herrenringe/006.jpg",
        ],

        [
          "Folie35/001.jpg",
          "Folie35/002.jpg",
          "Folie35/003.jpg",
          "Folie35/004.jpg",
          "Folie35/005.jpg",
          "Folie35/006.jpg",
          "Folie35/007.jpg",
          "Folie35/008.jpg",
          "Folie35/009.jpg",
          "Folie35/010.jpg",
          "Folie35/011.jpg",
          "Folie35/012.jpg",
          "Folie35/013.jpg",
          "Folie35/014.jpg",
          "Folie35/015.jpg",
          "Folie35/016.jpg",
          "Folie35/017.jpg",
          "Folie35/018.jpg",
          "Folie35/019.jpg",
          "Folie35/020.jpg",
          "Folie35/021.jpg",
          "Folie35/022.jpg",
          "Folie35/023.jpg",
          "Folie35/024.jpg",
          "Folie35/025.jpg",
          "Folie35/026.jpg",
          "Folie35/027.jpg",
          "Folie35/028.jpg",
          "Folie35/029.jpg",
          "Folie35/030.jpg",
        ],
        [
          "Folie23/001.jpg",
          "Folie23/002.jpg",
          "Folie23/003.jpg",
          "Folie23/004.jpg",
          "Folie23/005.jpg",
          "Folie23/006.jpg",
          "Folie23/007.jpg",
          "Folie23/008.jpg",
          "Folie23/009.jpg",
          "Folie23/010.jpg",
          "Folie23/011.jpg",
          "Folie23/012.jpg",
          "Folie23/013.jpg",
          "Folie23/014.jpg",
          "Folie23/015.jpg",
          "Folie23/016.jpg",
        ]
      ];


      return imageList[curAni.value];
    });

    const getText = (filename: string) => {
      const textList: any = {
        "HR0719": "Hollywood Ring Classic, 6 Krappen",
        "HR0720": "Hollywood Ring mit Pave-Besatz, 6 Krappen",
        "HR0744": "Veiled Halo, 4 Krappen",
        "HR0744side": "Veiled Halo mit Pave-Besatz, 4 Krappen",
        "HR0725": "Universal Classic, 4 Krappen",
        "HR0726": "Universal Hidden Halo, 4 Krappen",
        "HR0727": "Universal Hidden Halo mit Pave-Besatz, 4 Krappen",
        "HR0745": "Universal Halo, 4 Krappen",
        "HR0745side": "Universal Halo mit Pave-Besatz, 4 Krappen",
        "HR0739": "Three Stone, 4 Krappen",
        "HR0739side": "Three Stone mit Pave-Besatz, 4 Krappen",
        "HR0724": "Three Stone, 4 Krappen",
        "HR0724side": "Three Stone mit Pave-Besatz, 4 Krappen",
        "HR0723": "Three Stone, 4 Krappen",
        "HR0723side": "Three Stone mit Pave-Besatz, 4 Krappen",

        "Folie33/001.jpg": "499€",
        "Folie33/002.jpg": "649€",
        "Folie33/003.jpg": "649€",
        "Folie33/004.jpg": "549€",
        "Folie33/005.jpg": "649€",
        "Folie33/006.jpg": "749€",
        "Folie33/007.jpg": "449€",
        "Folie33/008.jpg": "649€",
        "Folie33/009.jpg": "649€",
        "Folie33/010.jpg": "499€",
        "Folie33/011.jpg": "649€",
        "Folie33/012.jpg": "749€",

        "Folie34/001.jpg": "649€",
        "Folie34/002.jpg": "799€",
        "Folie34/003.jpg": "899€",
        "Folie34/004.jpg": "699€",
        "Folie34/005.jpg": "799€",
        "Folie34/006.jpg": "899€",

        "Folie54-Herrenringe/001.jpg": "649€",
        "Folie54-Herrenringe/002.jpg": "799€",
        "Folie54-Herrenringe/003.jpg": "899€",
        "Folie54-Herrenringe/004.jpg": "699€",
        "Folie54-Herrenringe/005.jpg": "799€",
        "Folie54-Herrenringe/006.jpg": "899€",
      }

      for (let text in textList) {
        if (filename.includes(text)) {
          return textList[text];
        }
      }
      return ""
    }

    const setCurrentImageIdx = () => {
      curImageIdx.value++;

      if (curImageIdx.value >= images.value.length) {
        //curAni.value = curAni.value + 1;

        //if (curAni.value > 5) curAni.value = 0;

        curImageIdx.value = 0;
      }
    };

    const intervalId = ref();

    const startAnimation = () => {
      if (intervalId.value) {
        clearInterval(intervalId.value);
        intervalId.value = null;
      } else {
        intervalId.value = setInterval(setCurrentImageIdx, aniSpeed);
      }
    };

    setTimeout(startAnimation, aniSpeed);

    return {startAnimation, images, curImageIdx, getText, aniVersion};
  },
});
</script>

<style>

.bounce-enter-active {
  animation: fadeInOpacity 2s;
}

.bounce-leave-active {
  animation: fadeOutOpacity 2s;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeOutOpacity {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

</style>
